import {useContext} from 'react'

import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck'
import IconPriceDrop from '@adv-mt/mt-svg-icons/lib/PriceDropEuro'
import {Body2} from '@adv-mt/ui/typography'

const BASE_CLASS = 'mt-actionAdFavorite-priceDropInlineButton'
const LABEL_CLASS = `${BASE_CLASS}Label`

const ActionAdFavoritePriceDropInlineButton = ({isMarked, commonButtonProps = {}}) => {
  const {i18n} = useContext(Context)
  const {onClick} = commonButtonProps

  if (isMarked) {
    return (
      <div className={`${BASE_CLASS} ${BASE_CLASS}--marked`}>
        <IconCircleCheck size={atomIconSizes.medium} />
        <Body2 className={`${LABEL_CLASS} ${LABEL_CLASS}--marked`}>
          {i18n.t('COMMON.PRICE_DROP.LABEL_ADDED_FEEDBACK')}
        </Body2>
      </div>
    )
  }

  const handleKeyDown = event => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onClick(event)
  }

  return (
    <div
      aria-label={i18n.t('COMMON.PRICE_DROP.BUTTON')}
      className={BASE_CLASS}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className={`${BASE_CLASS}Icon`}>
        <IconPriceDrop size={atomIconSizes.medium} />
      </div>
      <Body2 highlight link>
        {i18n.t('COMMON.PRICE_DROP.BUTTON')}
      </Body2>
    </div>
  )
}

ActionAdFavoritePriceDropInlineButton.displayName = 'ActionAdFavoritePriceDropInlineButton'

ActionAdFavoritePriceDropInlineButton.propTypes = {
  isMarked: PropTypes.bool,
  commonButtonProps: PropTypes.object
}

export default ActionAdFavoritePriceDropInlineButton
